import React,{ Component, createContext} from "react";
import SpindlApi from "modules/spindl-api";

export const AuthContext = createContext({});

export default class AuthProvider extends Component{
    constructor(props){
        super(props);
        const auth = JSON.parse(sessionStorage.getItem("auth"))
        if (auth && auth.authToken){
            SpindlApi.setAuthToken(auth.authToken)
        }
        this.state = {
            auth:auth,
            signIn:this.signIn
        }
    }

    signIn = (auth)=>{
        //write auth to session storage
        sessionStorage.setItem("auth", JSON.stringify(auth))
        //set bearer token 
        SpindlApi.setAuthToken(auth.authToken)
        //update app state to pass auth through provider
        this.setState({auth:auth})
    } 

    signOut = ()=>{
        //Delete auth from session
        sessionStorage.removeItem("auth")
        SpindlApi.unsetAuthToken()
        this.setState({auth:{}})
    }

    render(){
        return(<AuthContext.Provider value={{
            auth:this.state.auth, 
            signIn:this.signIn,
            signOut:this.signOut
        }}>{this.props.children}</AuthContext.Provider>)
    }
}


// WEBPACK FOOTER //
// ./src/providers/Auth/AuthProvider.jsx